import * as e from "react";
import { forwardRef as l } from "react";
const a = l(
  function(t, r) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: r,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...t
      },
      /* @__PURE__ */ e.createElement("rect", { height: 17, rx: 1.5, stroke: "#000", width: 11, x: 7.5, y: 1.5 }),
      /* @__PURE__ */ e.createElement("rect", { fill: "#ECECEC", height: 17, rx: 1.5, width: 11, x: 4.5, y: 5.5 }),
      /* @__PURE__ */ e.createElement("rect", { height: 17, rx: 1.5, stroke: "#000", width: 11, x: 4.5, y: 5.5 })
    );
  }
);
export {
  a as BetBuilderBadgeYellowCards
};
